/** VUEX module for user management **/
import responseNotification from '../lib/responseNotification.js'

import { confirmUpdate, approveUpdate, denyUpdate } from '../lib/api/calls'
import router from '../router/index'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    confirm (context, {token}) {
      confirmUpdate(token).then((response) => {
        if (!response.error) {
          delete localStorage.update_confirmation
          responseNotification(context, response, 'Confirmed Advertisement Successfully!')
          router.push('/')
        } else {
          responseNotification(context, response)
        }
      })
    },
    approve (context, {token}) {
      approveUpdate(token).then((response) => {
        if (!response.error) {
          delete localStorage.update_request_approval
          responseNotification(context, response, 'Approved Advertisement Successfully!')
          router.push('/')
        } else {
          responseNotification(context, response)
        }
      })
    },
    deny (context, {token}) {
      denyUpdate(token).then((response) => {
        if (!response.error) {
          delete localStorage.update_request_denial
          responseNotification(context, response, 'Denied Advertisement Successfully!')
          router.push('/')
        } else {
          responseNotification(context, response)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/updates.js